(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naked-original-home"] && !Shopify.designMode) return;
  try {
    
function initializeNakedBanners(root=document){
  root.querySelectorAll('[data-naked-original]').forEach(section=>{
    if(section.dataset.ready)return;
    section.dataset.ready='true';
    const track=section.querySelector('.naked-original__slides');
    const status=section.querySelector('[data-banner-status]');
    const slides=track.querySelectorAll('.naked-original__slide');
    const current=()=>Math.round(track.scrollLeft/Math.max(track.clientWidth,1));
    const update=()=>{status.textContent=`${current()+1} / ${slides.length}`};
    section.querySelectorAll('[data-banner-step]').forEach(button=>button.addEventListener('click',()=>{
      const next=(current()+Number(button.dataset.bannerStep)+slides.length)%slides.length;
      track.scrollTo({left:next*track.clientWidth,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    }));
    track.addEventListener('scroll',update,{passive:true});
    update();
  });
}
initializeNakedBanners();
document.addEventListener('shopify:section:load',event=>initializeNakedBanners(event.target));

  } catch(e) { console.error(e); }
})();
})();
